import React, {useState,useContext} from 'react';

import {Link} from 'react-router-dom';

import '../../App.css';
import {MyContext} from '../login/MyContext';

import LogoMenu from '../assets/plantilla/menu/logo.png';
import LogoUsuario from '../assets/plantilla/menu/user2-160x160.jpg';
import Usuarios from '../assets/plantilla/menu/usuarios.png';
import Crear_usuarios from '../assets/plantilla/menu/crear_usuarios.png';
import Ver_usuarios from '../assets/plantilla/menu/ver_usuarios.png';
import Compras from '../assets/plantilla/menu/compras.png';
import Ingresos from '../assets/plantilla/menu/ingresos.png';
import Proveedores from '../assets/plantilla/menu/proveedores.png';
import Ventas from '../assets/plantilla/menu/ventas.png';
import Ventas_submenu from '../assets/plantilla/menu/ventas_submenu.png';
import Clientes from '../assets/plantilla/menu/clientes.png';
import Inventarios from '../assets/plantilla/menu/inventarios.png';
import Categorias from '../assets/plantilla/menu/categorias.png';
import Articulos from '../assets/plantilla/menu/articulos.png';
import Reportes from '../assets/plantilla/menu/reportes.png';
import Reportes_submenu from '../assets/plantilla/menu/reportes_submenu.png';
import Kardex from '../assets/plantilla/menu/kardex.png';

function Menu(props) {
  const {rootState,logoutUser} = useContext(MyContext);

  
  const [dropdown, setDropdown]=useState(false);
  const {isAuth,theUser,showLogin} = rootState;

  const abrirCerrarDropdown=()=>{
    setDropdown(!dropdown);
  }
    
  return (
    <nav className="navbar  main-sidebar sidebar-light-primary elevation-4 " >
  
  
   <center>
  <a href="#" className="brand-link">
      <img src={LogoMenu} alt="GEMCONT" width="40px" />
      <span className="brand-text font-weight-light"></span>
    </a>   </center>  

   
    <div className=" scrollb ">
      <div className="user-panel mt-3 pb-3 mb-3 d-flex">
        <div className="image">
          <img src={LogoUsuario} className="img-circle elevation-2" alt="USUARIO"  width="170px" height="170px" />
        </div>
        <div className="info">
          <a href="#" className="d-block">{theUser.name}</a>
          
         
            <button className="btn btn-primary" onClick={logoutUser} > Salir <i className="fas fa-sign-out-alt"></i></button>
            
            
            
        </div>
      </div>

      <nav className="mt-2">
    
   
      <ul className="nav navbar-nav nav-pills nav-sidebar flex-column" data-widget="treeview" role="menu" data-accordion="false">         


 { theUser.rol =="admin"
          ?<li className="dropdown nav-item menu-open">
          <a href="#" className="nav-link  administradores " data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">
          <i> <img src={Usuarios} width="35px" /></i>
          <p className="administradores">
          &nbsp; Usuarios
                <i className="right fas fa-angle-left"></i>
              </p>
          </a>
          <ul className="dropdown-menu">
          <li className="nav-item">
            <Link to="/Crear_usuarios" className="nav-link">
            <i> <img src={Crear_usuarios} width="35px" /></i>
            <p>
               &nbsp;Crear usuarios
             <b className="caret" />
           </p>
            </Link>
        </li>


        <li className="nav-item">
            <Link to="/Ver_usuarios" className="nav-link">
            <i> <img src={Ver_usuarios} width="35px" /></i>
            <p>
               &nbsp;Ver usuarios
             <b className="caret" />
           </p>
            </Link>
        </li>
      
   
          </ul>
        </li>

: ""
}


{ theUser.rol =="usuario"
          ?<li className="dropdown nav-item menu-open">
          <a href="#" className="nav-link  administradores " data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">
          <i> <img src={Compras} width="35px" /></i>
          <p className="administradores">
          &nbsp; Compras
                <i className="right fas fa-angle-left"></i>
              </p>
          </a>
          <ul className="dropdown-menu">
          <li className="nav-item">
            <Link to="/Register" className="nav-link">
            <i> <img src={Ingresos} width="35px" /></i>
            <p>
               &nbsp;Ingresos
             <b className="caret" />
           </p>
            </Link>
        </li>


        <li className="nav-item">
            <Link to="/Proveedores" className="nav-link">
            <i> <img src={Proveedores} width="35px" /></i>
            <p>
               &nbsp;Proveedores
             <b className="caret" />
           </p>
            </Link>
        </li>
      
   
          </ul>
        </li>

: ""
}



{ theUser.rol =="usuario"
          ?<li className="dropdown nav-item menu-open">
          <a href="#" className="nav-link  administradores " data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">
          <i> <img src={Ventas} width="35px" /></i>
          <p className="administradores">
          &nbsp; Ventas
                <i className="right fas fa-angle-left"></i>
              </p>
          </a>
          <ul className="dropdown-menu">
          <li className="nav-item">
            <Link to="/Register" className="nav-link">
            <i> <img src={Ventas_submenu} width="35px" /></i>
            <p>
               &nbsp;Ventas
             <b className="caret" />
           </p>
            </Link>
        </li>


        <li className="nav-item">
            <Link to="/Clientes" className="nav-link">
            <i> <img src={Clientes} width="35px" /></i>
            <p>
               &nbsp;Clientes
             <b className="caret" />
           </p>
            </Link>
        </li>
      
   
          </ul>
        </li>

: ""
}



{ theUser.rol =="usuario"
          ?<li className="dropdown nav-item menu-open">
          <a href="#" className="nav-link  administradores " data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">
          <i> <img src={Inventarios} width="35px" /></i>
          <p className="administradores">
          &nbsp; Inventarios
                <i className="right fas fa-angle-left"></i>
              </p>
          </a>
          <ul className="dropdown-menu">
          <li className="nav-item">
            <Link to="/Categorias" className="nav-link">
            <i> <img src={Categorias} width="35px" /></i>
            <p>
               &nbsp;Categorias
             <b className="caret" />
           </p>
            </Link>
        </li>


        <li className="nav-item">
            <Link to="/Articulos" className="nav-link">
            <i> <img src={Articulos} width="35px" /></i>
            <p>
               &nbsp;Articulos
             <b className="caret" />
           </p>
            </Link>
        </li>
      
   
          </ul>
        </li>

: ""
}



{ theUser.rol =="usuario"
          ?<li className="dropdown nav-item menu-open">
          <a href="#" className="nav-link  administradores " data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">
          <i> <img src={Reportes} width="35px" /></i>
          <p className="administradores">
          &nbsp; Reportes
                <i className="right fas fa-angle-left"></i>
              </p>
          </a>
          <ul className="dropdown-menu">
          <li className="nav-item">
            <Link to="/Register" className="nav-link">
            <i> <img src={Reportes_submenu} width="35px" /></i>
            <p>
               &nbsp;Reporte de compras
             <b className="caret" />
           </p>
            </Link>
        </li>


        <li className="nav-item">
            <Link to="/Administrador" className="nav-link">
            <i> <img src={Reportes_submenu} width="35px" /></i>
            <p>
               &nbsp;Reporte de ventas
             <b className="caret" />
           </p>
            </Link>
        </li>


        <li className="nav-item">
            <Link to="/Administrador" className="nav-link">
            <i> <img src={Kardex} width="35px" /></i>
            <p>
               &nbsp;Kardex
             <b className="caret" />
           </p>
            </Link>
        </li>
      
   
          </ul>
        </li>

: ""
}



      </ul>
      

     

      <ul className="nav navbar-nav nav-pills nav-sidebar flex-column">
      
        
      </ul>
    
    </nav>
  </div>

</nav>
       
    )

    
  }

 


export default Menu